module.exports = __webpack_public_path__ + "static/img/yangcong.18138362.png";